import StateType from './state.type';

export default {
  loading: true,
  clientInfo: {},
} as StateType;
